import React, { createContext, useState, Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { AuthProvider } from 'context/AuthContext';
import PrivateRoute from 'context/PrivateRoute'

// layouts
import TestLayout from 'components/layouts/TestLayout';
import AuthLayout from 'components/layouts/AuthLayout';
import MainLayout from 'components/layouts/MainLayout';
import OnboardingLayout from 'components/layouts/OnboardingLayout';

// auth pages
import ForgotPassword from 'components/auth/ForgotPassword'
import Onboarding from 'components/auth/Onboarding'
import Settings from 'components/auth/Settings'
import Signup from 'components/auth/Signup'
import Login from 'components/auth/Login'
import Home from 'components/auth/Home'
import Test from 'components/auth/Test'

export const AppState = createContext()

function App() {

    const [appState, setAppState] = useState({

        // CONTEXTS
        tagContext: null,
        loadingContext: null,
        dateContext: null,
        favouriteContext: null,
        latitude: null,
        longitude: null,

        // APP SETTINGS
        tooltips: true,
        isMapDark: null,
        barOpen: false,

        // USER SETTINGS
        username: null,
        userPhoto: null,
        newUser: null,

        tourContext:true,

        // POST SETTINGS
        currentPost: null
    })

    return (
        <Suspense fallback="loading">
            <AuthProvider>
                <AppState.Provider value={[appState, setAppState]}>
                    <Router>
                        <Switch>

                            <Route path={['/test']} exact>
                                <TestLayout>
                                    <Route path={'/test'} exact component={Test} />
                                </TestLayout>
                            </Route>

                            <Route path={['/login','/signup','/test']} exact>
                                <AuthLayout>
                                    <Route path={'/login'} exact component={Login} />
                                    <Route path={'/signup'} exact component={Signup} />
                                    <Route path={'/test'} exact component={Test} />
                                </AuthLayout>
                            </Route>

                            <PrivateRoute path={['/','/settings']} exact>
                                <MainLayout>
                                    <PrivateRoute path={'/'} exact component={Home} />
                                    <PrivateRoute path={'/settings'} exact component={Settings} />
                                </MainLayout>
                            </PrivateRoute>

                            <PrivateRoute path={['/onboarding']} exact>
                                <OnboardingLayout>
                                    <PrivateRoute path={'/onboarding'} exact component={Onboarding} />
                                </OnboardingLayout>
                            </PrivateRoute>

                            <Route component={() => <div>404</div>}></Route>
                        </Switch>
                    </Router>
                </AppState.Provider>
            </AuthProvider>
        </Suspense>
    );
}

export default App;